import React from 'react';

export const DetailRow = ({ label, boldRow, boldValue, children }) => {
  const valueClassName = boldRow || boldValue ? undefined : 'text-dark-50';

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span className='text-dark' style={{ fontSize: 14, fontWeight: boldRow ? 700 : 'normal' }}>{label}</span>
      <span
        className={valueClassName}
        style={{ textAlign: 'right', fontSize: 14, fontWeight: boldRow ? 700 : boldValue ? 500 : 'normal' }}
      >
        {children}
      </span>
    </div>
  );
};
